import React from "react";

interface DepartureStationPopoverTriggerProps {
    departureTime: string,
}

function DepartureStationPopoverTrigger({departureTime}: DepartureStationPopoverTriggerProps) {
    return (
        <span className="gb--emphasize gb--emphasize-default gb--route-time">
            {departureTime}
        </span>
    )
}

export default DepartureStationPopoverTrigger